export default class Forms {

	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new Forms;
		self.attachEvents();
	}

	static initSelectric($selects) {
		const self = new Forms;
		self.attachSelectric($selects);
	}

	static setResolutionInputs() {
        $('input[name="_resolution"]').val(
            window.screen.width + "x" + window.screen.height
        );
    }

	attachEvents() {
		const self = this;

		self.attachSelectric($('.js-selectric'));

		$(document).on('change', '.js-toggle-delivery-address', function() {
			self.toggleDeliveryAddress($(this));
		});
	}

	attachSelectric($selects) {
		const self = this;

		$selects.each(function() {
			var $select = $(this);

			$select.selectric({
				disableOnMobile: ($select.data('selectric-mobile') == false ? false : true),
				nativeOnMobile: ($select.data('selectric-mobile') == false ? false : true),
			});
		});
	}

	toggleDeliveryAddress() {
		const self = this;
		console.log($('#billing_address_different').is(':checked'));

		if ($('#billing_address_different').is(':checked')) {
			$('.billing-address-fields').slideDown();

		} else {
			$('.billing-address-fields').slideUp();
		}
	}
}